import React from 'react';
import { Stack, Typography } from '@mui/material';

/**
 * A bold label followed by its value, e.g. "Client: Acme Ltd".
 * Plain text values are wrapped in a Typography; anything else renders as given.
 */
export const HeaderDetail = ({ label, children, testId }) => (
	<Stack direction='row' alignItems='center' spacing={1}>
		<Typography sx={{ fontWeight: 'bold' }}>{label}:</Typography>
		{React.isValidElement(children) ? (
			children
		) : (
			<Typography data-testid={testId}>{children}</Typography>
		)}
	</Stack>
);
